import { ComponentProps, memo, ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { BasicSwitcher } from 'newelements/_Betslip/components/shared/Switchers/BasicSwitcher';
import { toggleQuickBet } from 'newelements/_Betslip/managers/QuickBetManager/quickBetActions';
import { getQuickBetEnabled } from 'store/selectors/betslip';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

export type TQuickBetBaseSwitcherProps = {
  tooltip?: boolean;
  className?: string;
  isActive?: boolean;
};
export const QuickBetBaseSwitcher = memo(
  ({
    tooltip,
    isActive,
    className
  }: TQuickBetBaseSwitcherProps): ReactElement | null => {
    const isQuickBetEnabled = useSelector(getQuickBetEnabled);

    const { t } = useTranslation();

    const computedProps = useMemo<
      Pick<
        ComponentProps<typeof BasicSwitcher>,
        'className' | 'featureIsActive' | 'tooltipText'
      >
    >(
      () => ({
        className,
        featureIsActive: isActive ?? isQuickBetEnabled,
        ...(tooltip ? { tooltipText: t('betslip.quickbetModeMessage') } : {})
      }),
      [tooltip, className, isActive, isQuickBetEnabled]
    );

    return (
      <BasicSwitcher
        {...computedProps}
        skipRowStyles={isMobile()}
        setFeatureIsActive={() => {
          toggleQuickBet();
        }}
        featureName={t('betslip.quickbet')}
      />
    );
  }
);
